import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import each from 'lodash/each';
import { formatPhoneNumber } from 'yoda-account-components/lib/helpers/PhoneNumberFormatter/PhoneNumberFormatter';
import {
    SHIPPING_GROUP_TYPE_STORE,
    SHIPPING_GROUP_TYPE_HOME,
} from 'yoda-checkout-components/lib/common/Constants';
import { validateAlternatePickupPersonFormField } from '../helpers/Utils/Utils';
import * as actionTypes from '../actionTypes/SameDayPickupActionTypes';
import ShippingService from '../services/ShippingService';
import PaymentConstants from '../helpers/PaymentConstants';

export default function NewBOPISReducer(state = {}, action) {
    // NOSONAR
    /*
     * {
     *      'bopisItemList': [{imageUrl: '', qty: 1}, ..]
     *      'storeInfo': {
     *          id: '',
     *          name: '',
     *          addressLineOne: '',
     *          addressLineTwo: '',
     *          phone: '',
     *          timings: [],
     *          isCurbSideEligible': true / false,
     *      },
     *      'showAlternatePickPerson':true/false,
     *      'pickupPersonInfo' : {
     *          'firstName': '',
     *          'lastName': '',
     *          'email': '',
     *          'phone': '',
     *      },
     *      'pickupPersonInfoTouchedFields' : {
     *          'firstName': '',
     *          'lastName': '',
     *          'email': '',
     *          'phone': '',
     *      },
     *      'pickupPersonInfoErrors' : {
     *          'firstName': '',
     *          'lastName': '',
     *          'email': '',
     *          'phone': '',
     *      },
     *      submitAction: 'Shipping/Payment/Review',
     * }
     *
     */
    switch (
        action.type // NOSONAR
    ) {
        case actionTypes.INIT_BOPIS_SECTION_UI: {
            const { orderDetailsInfo } = action;
            const storeInfo = ShippingService.getStoreInfoUI(action.storeInfo);
            const { isLoadedFromReview } = action;
            const deliveryGroup = get(orderDetailsInfo, 'data.delivery.groups', {});
            const bopisShippingGroup = find(deliveryGroup, (group) => group.type === 'BOPIS');
            const shipToOtherGroup = ShippingService.getOrderShippingAddress(orderDetailsInfo);
            const bopisItemList = [];
            const items = get(orderDetailsInfo, 'data.bag.items', []);
            each(items, (item) => {
                const bopisDeliveryOptions = find(item.deliveryOptions, {
                    code: 'BOPIS',
                    selected: true,
                });
                if (bopisDeliveryOptions) {
                    const bopisItem = {
                        product: item.product,
                        quantity: item.quantity,
                    };
                    bopisItemList.push(bopisItem);
                }
            });
            const showAlternatePickPerson = get(
                bopisShippingGroup,
                'pickup.alternatePerson',
                false
            );
            const orderPickup = get(bopisShippingGroup, 'pickup', {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
            });
            const pickupPersonInfo = { ...orderPickup };
            if (pickupPersonInfo.phone) {
                pickupPersonInfo.phone = formatPhoneNumber(pickupPersonInfo.phone);
            }
            let submitAction = 'Shipping';
            const { pickup, address, type } = shipToOtherGroup;
            if (
                isEmpty(shipToOtherGroup) || // Order with BOPIS only item
                (!isEmpty(pickup) && type === SHIPPING_GROUP_TYPE_STORE) || // Order with store delivery
                (!isEmpty(address) && type === SHIPPING_GROUP_TYPE_HOME)
            ) {
                // Order with home delivery
                submitAction = 'Payment';
            }
            if (isLoadedFromReview) {
                submitAction = 'Review';
            }

            const updatedState = {
                bopisItemList,
                showAlternatePickPerson,
                pickupPersonInfo,
                pickupPersonInfoErrors: {},
                pickupPersonInfoTouchedFields: {},
                submitAction,
                storeInfo,
            };
            return { ...state, ...updatedState };
        }

        case actionTypes.SHOW_ALTERNATE_PICKUP_PERSON_FORM: {
            const { showAlternatePickPerson } = action;
            const pickupPersonInfoErrors = [];
            const pickupPersonInfoTouchedFields = [];
            return {
                ...state,
                pickupPersonInfoErrors,
                pickupPersonInfoTouchedFields,
                showAlternatePickPerson,
            };
        }

        case actionTypes.ALTERNATE_PICKUP_FORM_CHANGE_VALUE: {
            const { attribute } = action;
            let { newValue } = action;
            const pickupPersonInfo = { ...state.pickupPersonInfo };
            const pickupPersonInfoErrors = { ...state.pickupPersonInfoErrors };
            const { pickupPersonInfoTouchedFields } = state;
            if (attribute === 'phone') {
                if (newValue.length < PaymentConstants.PHONE_NUMBER_MAX_LENGTH) {
                    newValue = ShippingService.getFormattedPhoneNumber(newValue);
                } else {
                    newValue = pickupPersonInfo.phone;
                }
            }
            pickupPersonInfo[attribute] = newValue;
            const errorMessage = validateAlternatePickupPersonFormField(newValue, attribute);
            if (pickupPersonInfoTouchedFields[attribute] || isEmpty(errorMessage)) {
                pickupPersonInfoErrors[attribute] = errorMessage;
            }
            return { ...state, pickupPersonInfo, pickupPersonInfoErrors };
        }

        case actionTypes.ALTERNATE_PICKUP_FORM_FIELD_ERROR: {
            const { attribute } = action;
            const pickupPersonInfo = { ...state.pickupPersonInfo };
            const pickupPersonInfoErrors = { ...state.pickupPersonInfoErrors };
            const pickupPersonInfoTouchedFields = { ...state.pickupPersonInfoTouchedFields };
            const errorMessage = validateAlternatePickupPersonFormField(
                pickupPersonInfo[attribute],
                attribute
            );
            if (
                errorMessage === pickupPersonInfoErrors[attribute] &&
                pickupPersonInfoTouchedFields[attribute] === true
            ) {
                return state;
            }
            if (errorMessage) {
                pickupPersonInfoErrors[attribute] = errorMessage;
            }
            pickupPersonInfoTouchedFields[attribute] = true;
            return { ...state, pickupPersonInfoErrors, pickupPersonInfoTouchedFields };
        }

        case actionTypes.ALTERNATE_PICKUP_FORM_ERROR: {
            const pickupPersonInfoErrors = action.pickUpFormError;
            return { ...state, pickupPersonInfoErrors };
        }

        default:
            return state;
    }
}
